<template>
  <b-row style="margin-top: 2em">
    <b-col>
      <b-card bg-variant="light">
        <b-row>
          <b-col>
            <h5 class="text-info">{{ $t("globals.parking_invoices") }} {{ total }}:</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="my-3">
            <b-input-group>
              <b-form-input
                v-model="filter"
                :placeholder="$t('globals.type_to_search')"
              />
              <b-input-group-append>
                <b-btn
                  variant="warning"
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  {{ $t("globals.clear") }}
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="2" class="my-3">
            <b-form-select v-model="perPage" :options="perPageOptions" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table
              :items="invoices"
              :fields="fields"
              :filter="filter"
              :current-page="currentPage"
              @filtered="currentPage = 1"
              :sortable = false
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              hover
              small
              
              @row-clicked="rowClicked"
              sort-icon-left
              
              
            >
              <template v-slot:cell(total_price_in_cents_ex_vat)="item">
                {{
                  currencyFormat(
                    item.item.total_price_in_cents_ex_vat,
                    currency
                  )
                }}
              </template>
              <template v-slot:cell(created_at)="item">
                <div v-b-tooltip.hover :title="item.item.created_at">
                  {{ item.item.created_at.substring(0, 10) }}
                </div>
              </template>
              <template v-slot:cell(sent_at)="item">
                <div
                  v-b-tooltip.hover
                  :title="item.item.sent_at ? item.item.sent_at : ''"
                >
                  {{
                    item.item.sent_at ? item.item.sent_at.substring(0, 10) : ""
                  }}
                </div>
              </template>
              <template v-slot:cell(period_from)="item">
                {{
                  item.item.period_from
                    ? item.item.period_from.substring(0, 10)
                    : ""
                }}
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="total"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { currencyFormat } from "@/helpers/price";
import { mapGetters,mapMutations, mapActions } from "vuex";

export default {
  props: {
    customer:{
      type: Number,
      require: true
    },
    currency: String,
  },
  data() {
    return {
      total:0,
      invoices:[],
      filter: null,
      currentPage: 1,
      sortBy: "period_from",
      sortDesc: true,
      perPage: 20,
      fields: [
        
        {
          key: "id",
          label:"ID",
          sortable: true
        },
        {
          key: "invoice_no",
          label: this.$t("globals.invoice_no"),
          sortable: true
        },
        {
          key: "period_from",
          label: this.$t("globals.period_from"),
          sortable: true
        },
        {
          key: "status",
          label: this.$t("globals.status"),
          sortable: true
        },
        {
          key: "created_at",
          label: this.$t("globals.created_at"),
          sortable: true
        },
        {
          key: "sent_at",
          label: this.$t("globals.sent_at"),
          sortable: true
        },
        {
          key: "sent_to",
          label: this.$t("globals.sent_to"),
          sortable: true
        },
        {
          key: "total_price_in_cents_ex_vat",
          label: this.$t("globals.total_price_no_vat"),
          sortable: true
        }
      ],
      items: [],
      perPageOptions: [
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "40 " + this.$t("globals.per_page"), value: 40 },
        { text: "60 " + this.$t("globals.per_page"), value: 60 }
      ]
    };
  },
  computed: {
    ...mapGetters(["getLocale", "getBackendUrl"])
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    ...mapActions("axios_mod", ["simpleFetch"]),
    currencyFormat,
    rowClicked(item) {
      window.open(
        `${this.getBackendUrl}/pdf_parking_invoices/${item.id}.pdf?locale=${this.getLocale}`,
        "_blank"
      );
    },
    fetchTotalParkingInvoices(){
      const data = {
        query: `query { Customer(id:${parseInt(this.customer)}){ parking_invoices_total }}`
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.total = res.Customer.parking_invoices_total;
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
      });
    },
    fetchInvoices() {
      const offset = (this.currentPage-1) * this.perPage;
      const sort = this.sortDesc ? 'desc' : 'asc'
      const data = {
        query: `
        query {
          Customer(id:${parseInt(this.customer)}){ 
            parkingInvoicesPagination (
              sortBy:"${this.sortBy}", 
              sort:"${sort}"
              limit: ${parseInt(this.perPage)},
              offset: ${parseInt(offset)}
            ){ 
                id
                invoice_no
                period_from
                status
                total_price_in_cents_ex_vat
                total_price_in_cents_with_vat
                created_at
                sent_at
                sent_to
            }
          }
        }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.invoices = res.Customer.parkingInvoicesPagination;
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
        });
    },
  },
  mounted() {
    this.fetchTotalParkingInvoices();
  },
  watch:{
    total(n,o){
      if(this.total>0){
        this.fetchInvoices();
      }
    },
    currentPage(n,o){
      this.fetchInvoices();
    },
    perPage(n,o){
      this.fetchInvoices();
    },
    sortBy(n,o){
      this.fetchInvoices();
      // this.currentPage = 1; // To stay in the current page keep this commented, if after a sort it needs to go to the first page, uncomment
    },
    sortDesc(n,o){
      this.fetchInvoices();
      // this.currentPage = 1; // To stay in the current page keep this commented, if after a sort it needs to go to the first page, uncomment
    }
  }
};
</script>
